import { type SASearchFormFields, SearchTypesSP } from "../components/SearchCard/SalesPartnerSearchBox";
import { resolveApiUrl } from "../../utils/url/urlResolver";

export interface InputsData extends SASearchFormFields {
  countryCode: string;
}

export type UrlParams = Pick<
  InputsData,
  "partner" | "address" | "radius" | "countryCode" | "searchType" | "filterByCountry" | "productCompetence" | "certifiedCompetence"
> & {
  preferredSalesPartner?: string;
  lat?: number,
  lng?: number,
  salesPartnerId?: string
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSalesPartnerSearch(inputsData: UrlParams, pageNumber?: number): Promise<any> {
  const url = createUrlFromInputValues(inputsData, pageNumber);
  return fetch(url, {
    method: "GET",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json();
    }
  });
}

export function createUrlFromInputValues(inputsData: UrlParams, pageNumber?: number): string {
  const params = new URLSearchParams();

  params.set("searchType", inputsData.searchType);

  if (inputsData.searchType === SearchTypesSP.Partner) {
    params.set("q", inputsData.partner);
  } else {
    params.set("q", inputsData.address);
    if (inputsData.radius !== -1) {
      params.set("radius", String(inputsData.radius));
    }
  }

  if (inputsData.lat) {
    params.set("latitude", `${inputsData.lat}8`); // i don't know what the "8" stands for
  }
  if (inputsData.lng) {
    params.set("longitude", `${inputsData.lng}`);
  }

  if (inputsData.filterByCountry) {
    params.set("country", inputsData.countryCode);
  }

  if (inputsData.salesPartnerId) {
    params.set("preferredSalesPartner", inputsData.salesPartnerId);
  }
  if (pageNumber) {
    params.set("page", String(pageNumber));
  }
  if (inputsData.productCompetence?.length) {
    params.set("productCompetence", String(inputsData.productCompetence));
  }
  if (inputsData.certifiedCompetence?.length) {
    params.set("certifiedCompetence", String(inputsData.certifiedCompetence));
  }

  return resolveApiUrl(`/store-finder/search?${params}`);
}
